'use client';

import { useEffect, useState } from 'react';

const WA_HREF =
  'https://wa.me/33648604515?text=Bonjour%20Cindy%2C%20je%20souhaite%20en%20savoir%20plus%20sur%20vos%20services.';

export default function WhatsAppFloat() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const section = document.getElementById('contact');
    if (!section) return;
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      threshold: 0.1,
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  if (!visible) return null;

  return (
    <a
      href={WA_HREF}
      target="_blank"
      rel="noopener noreferrer"
      className="t-wa-float"
      aria-label="Contacter sur WhatsApp"
    >
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.117 1.528 5.845L.057 23.272a.75.75 0 0 0 .92.92l5.42-1.47A11.946 11.946 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.696 9.696 0 0 1-4.964-1.363l-.356-.212-3.687 1 1.003-3.593-.233-.372A9.696 9.696 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z" />
      </svg>
      WhatsApp
    </a>
  );
}
